import { render, staticRenderFns } from "./generatedRecords.vue?vue&type=template&id=1e2c5010&scoped=true&"
import script from "./generatedRecords.vue?vue&type=script&lang=js&"
export * from "./generatedRecords.vue?vue&type=script&lang=js&"
import style0 from "./generatedRecords.vue?vue&type=style&index=0&id=1e2c5010&prod&scoped=true&lang=css&"
import style1 from "./generatedRecords.vue?vue&type=style&index=1&id=1e2c5010&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2c5010",
  null
  
)

export default component.exports